// extracted by mini-css-extract-plugin
module.exports = {"logo_stage":"SuperLogo_logo_stage__3RkSg","super":"SuperLogo_super__1rH-_","rotate3d":"SuperLogo_rotate3d__1Dupg"};